import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { map, catchError } from 'rxjs/operators';

@Injectable()
export class CartoesContratosService extends BaseService {

  constructor(private http: HttpClient) { super(); }

  getContrato(id: number) {
    return this.http.get(`${this.UrlService}cartoesContratos/getById/${id}`).pipe(map(super.extractData)
      , catchError(super.serviceError));
  }

  get() {
    return this.http.get(this.UrlService + 'cartoescontratos')
      .pipe(map(super.extractData)
        , catchError(super.serviceError));
  }

  delete(id: number) {
    return this.http.delete(this.UrlService + `CartoesContratos/${id}`)
      .pipe(map(super.extractData)
        , catchError(super.serviceError));
  }

  post(form: any) {
    return this.http.post(this.UrlService + 'CartoesContratos', form)
      .pipe(map(super.extractData)
        , catchError(super.serviceError))
  }

  postForm(form: any) {
    return this.http
      .post(this.UrlService + 'cartoescontratos/salvar', form)
      .pipe(map((res: any) => res.data)
        , catchError(super.serviceError))
  }

  putForm(form) {
    return this.http
      .put(this.UrlService + `cartoescontratos/alterar/`, form)
      .pipe(map((res: any) => res.data)
        , catchError(super.serviceError))
  }

  getPaginado(pagina: number, filtro: string) {
  return this.http.get(this.UrlService + 'cartoescontratos/GetPaginado?pageIndex=' + pagina + '&search=' + filtro)
    .pipe(map((res: any) => res.data), catchError(super.serviceError));
  }
}
